import { escapeAttr } from "@emkit/builder-core";
export const DIVIDER_DEFAULTS = {
    color: "currentColor",
    thickness: 1,
    style: "solid",
    spacing: 16,
};
export const dividerWidget = {
    type: "divider",
    defaultProps: DIVIDER_DEFAULTS,
    renderHtml(props) {
        const thickness = Math.max(1, Math.min(props.thickness ?? 1, 10));
        const styleStr = [
            "border:0",
            `border-top:${thickness}px ${props.style ?? "solid"} ${escapeAttr(props.color ?? "currentColor")}`,
            "opacity:0.15",
            `margin:${props.spacing ?? 16}px 0`,
        ].join(";");
        return `<hr class="emk-divider" style="${styleStr}">`;
    },
};
//# sourceMappingURL=divider.js.map